// Datum v appce se ukládá/přenáší jako ISO 'YYYY-MM-DD' (případně s časovou
// částí) - pro zobrazení uživateli se v Česku obvykle používá DD.MM.RRRR.
export function formatDateDisplay(dateStr) {
  if (!dateStr) return '';
  const datePart = String(dateStr).slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
  if (!match) return dateStr;
  const [, year, month, day] = match;
  return `${day}.${month}.${year}`;
}
